/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data is updated after each Grand Prix weekend. Qualifying results, race outcomes, sprint events, and fastest laps are all captured and reflected in our scoring engine within hours of the race completing.`)
};

const es_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los datos se actualizan después de cada fin de semana de Gran Premio. Resultados de clasificación, resultados de carrera, eventos sprint y vueltas rápidas se capturan y reflejan en nuestro motor de puntuación dentro de las horas posteriores a la carrera.`)
};

const de_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten werden nach jedem Grand-Prix-Wochenende aktualisiert. Qualifying-Ergebnisse, Rennergebnisse, Sprint-Events und schnellste Runden werden erfasst und innerhalb von Stunden nach Rennende in unserer Bewertungs-Engine widergespiegelt.`)
};

const nl_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens worden bijgewerkt na elk Grand Prix-weekend. Kwalificatieresultaten, race-uitslagen, sprintevenementen en snelste rondes worden allemaal vastgelegd en verwerkt in onze scoring-engine binnen enkele uren na afloop van de race.`)
};

const fr_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les données sont mises à jour après chaque week-end de Grand Prix. Les résultats des qualifications, les issues des courses, les événements sprint et les tours les plus rapides sont tous capturés et reflétés dans notre moteur de notation dans les heures suivant la fin de la course.`)
};

const it_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dati vengono aggiornati dopo ogni weekend di Gran Premio. Risultati qualifiche, esiti gara, eventi sprint e giri veloci vengono tutti registrati e riflessi nel nostro motore di punteggio entro poche ore dal completamento della gara.`)
};

const pt_br2_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dados são atualizados após cada fim de semana de Grande Prêmio. Resultados de classificatória, resultados de corrida, eventos sprint e voltas mais rápidas são todos capturados e refletidos em nosso motor de pontuação em poucas horas após a conclusão da corrida.`)
};

const pt_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dados são atualizados após cada fim de semana de Grande Prémio. Resultados de qualificação, resultados de corrida, eventos sprint e voltas mais rápidas são todos captados e refletidos no nosso motor de pontuação em poucas horas após a corrida.`)
};

const ja_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データは各グランプリウィークエンド後に更新されます。予選結果、レース結果、スプリントイベント、ファステストラップはすべてレース終了後数時間以内にスコアリングエンジンに反映。`)
};

const zh_about_data_sources_p2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据在每个大奖赛周末后更新。排位赛结果、比赛结果、冲刺赛事和最快圈速均会在比赛结束后数小时内被捕获并反映在我们的评分引擎中。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_data_sources_p2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_data_sources_p2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_data_sources_p2", locale)
	if (locale === "en") return en_about_data_sources_p2(inputs)
	if (locale === "es") return es_about_data_sources_p2(inputs)
	if (locale === "de") return de_about_data_sources_p2(inputs)
	if (locale === "nl") return nl_about_data_sources_p2(inputs)
	if (locale === "fr") return fr_about_data_sources_p2(inputs)
	if (locale === "it") return it_about_data_sources_p2(inputs)
	if (locale === "pt-BR") return pt_br2_about_data_sources_p2(inputs)
	if (locale === "pt") return pt_about_data_sources_p2(inputs)
	if (locale === "ja") return ja_about_data_sources_p2(inputs)
	return zh_about_data_sources_p2(inputs)
};